import { useMemo } from "react";
import { useLoader } from "@react-three/fiber";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import * as THREE from "three";

// three@0.160 nie ma jeszcze scene.environmentRotation, więc obrót HDRI
// (w osi "górnej", czyli Z w konwencji Blendera / Y w three.js) robimy
// ręcznie - cyklicznym przesunięciem pikseli w wierszach tekstury equirect,
// zanim trafi do PMREM.
function rotateEquirectHorizontally(texture, angleDegrees) {
  const { width, height } = texture.image;
  const channels = 4;

  if (!texture.userData.__originalData) {
    texture.userData.__originalData = texture.image.data.slice();
  }
  const source = texture.userData.__originalData;

  const shift =
    ((Math.round((angleDegrees / 360) * width) % width) + width) % width;

  if (shift === 0) {
    texture.image.data = source.slice();
    texture.needsUpdate = true;
    return texture;
  }

  const rowLength = width * channels;
  const rotated = new source.constructor(source.length);

  for (let y = 0; y < height; y++) {
    const rowStart = y * rowLength;
    for (let x = 0; x < width; x++) {
      const srcX = (x - shift + width) % width;
      const src = rowStart + srcX * channels;
      const dst = rowStart + x * channels;
      rotated[dst] = source[src];
      rotated[dst + 1] = source[src + 1];
      rotated[dst + 2] = source[src + 2];
      rotated[dst + 3] = source[src + 3];
    }
  }

  texture.image.data = rotated;
  texture.needsUpdate = true;
  return texture;
}

export function useRotatedHDRI(path, angleDegrees = 0) {
  // Rozszerzenie sprawdzamy po odcięciu query stringa (np. "?v=<hash>"
  // doklejanego dla cache-bustingu) - inaczej ".hdr?v=..." nie pasuje.
  const cleanPath = path.split("?")[0].toLowerCase();
  const loader = cleanPath.endsWith(".hdr") ? RGBELoader : EXRLoader;
  const texture = useLoader(loader, path);

  return useMemo(() => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    rotateEquirectHorizontally(texture, angleDegrees);
    return texture;
  }, [texture, angleDegrees]);
}
